module.exports = __webpack_public_path__ + "media/10.4df3b41d.mp3";